import {
  GET_ALL_APP_USERS,
  GET_APP_USER,
  GET_JOB_TITLES,
  GET_MANAGERS_USERS,
  GET_ALL_EXT_USERS
} from '../actionTypes';
import { getAxiosInstance } from '../utils/axios-api';
import { getAccessToken } from '../utils/customMethods';
import { notify } from '../utils/notifications/notifications';

export const getAppUserList = () => async dispatch => {
  const response = await getAxiosInstance().get(
    `/getUsersList?access_token=${getAccessToken()}`
  );

  response.status === 200
    ? dispatch({
        type: GET_ALL_APP_USERS,
        payload: response.data || undefined,
      })
    : dispatch({
        type: GET_ALL_APP_USERS,
        payload: undefined,
      });
};

export const getManagersUsers = id => async dispatch => {
  try {
    const response = await getAxiosInstance().get(
      `/usersByManager/${id}?access_token=${getAccessToken()}`
    );

    if (response) {
      dispatch({
        type: GET_MANAGERS_USERS,
        payload: response.data || undefined,
      });
    }
  } catch (error) {
    notify('error', 'ERROR. PLEASE TRY AGAIN OR CONTACT ADMINISTRATOR');
  }
};

export const getJobTitles = () => async dispatch => {
  const response = await getAxiosInstance().get(
    `/jobTitles?access_token=${getAccessToken()}`
  );

  return response.status === 200
    ? dispatch({
        type: GET_JOB_TITLES,
        payload: response.data || undefined,
      })
    : null;
};

export const getVendors = () => async dispatch => {
  try {
    const response = await getAxiosInstance().get(
      `/vendors?access_token=${getAccessToken()}`
    );

    return response.status === 200 ? response.data || [] : [];
  } catch (ex) {
    return [];
  }
};
export const getClientManagers=()=>async dispatch=>{
  try{
    const response=await getAxiosInstance().get(
      `/getClientManagers?access_token=${getAccessToken()}`
    );
    response.status === 200
    ? dispatch({
        type: GET_ALL_EXT_USERS,
        payload: response.data || undefined,
      })
    : dispatch({
        type: GET_ALL_EXT_USERS,
        payload: undefined,
      });
    return response.status === 200 ? response.data || [] : [];
  }catch(ex){
    dispatch({
      type: GET_ALL_EXT_USERS,
      payload: undefined,
    });
    return[];
  }
}
export const getOnboardingTypes=()=>async dispatch=>{
  try{
    const response=await getAxiosInstance().get(
      `/getOnboardingTypes?access_token=${getAccessToken()}`
    );
    return response.status === 200 ? response.data || [] : [];
  }catch(ex){
    return[];
  }
}

export const getAppUser = userId => async dispatch => {
  try {
    const response = await getAxiosInstance().get(
      `/getUsersList?userId=${userId}&access_token=${getAccessToken()}`
    );
   // console.log('GET APP USERS RESPONSE', response);
    dispatch({
      type: GET_APP_USER,
      payload: response.data[0] || undefined,
    });
  } catch (ex) {
    dispatch({
      type: GET_APP_USER,
      payload: undefined,
    });
  }
};

export const clearAppUser = () => async dispatch => {
  dispatch({
    type: GET_APP_USER,
    payload: undefined,
  });
};

export const saveAppUser = (body, userId) => async dispatch => {
  //console.log('BODY', body);
  try {
    if ((userId || 0) > 0) {
      const response = await getAxiosInstance().put(
        `/saveUser?access_token=${getAccessToken()}`,
        body
      );
      if (response.status === 200) {
        // console.log('RESPONSE', response);
        notify('success', 'User updated successfully');
        return true;
      } else {
        notify('error', 'User updated failed');
        return false;
      }
    } else {
      const response = await getAxiosInstance().post(
        `/saveUser?access_token=${getAccessToken()}`,
        body
      );
      if (response.status === 200) {
        notify('success', 'User added successfully');
        return true;
      } else {
        return false;
      }
    }
  } catch (ex) {
    notify('error', 'Something went wrong. Please try again');
    return false;
  }
};

export const saveClientManager = (body, userId) => async dispatch => {
  try {
    if ((userId || 0) > 0) {
      const response = await getAxiosInstance().put(
        `/saveClientManagers?access_token=${getAccessToken()}`,
        body
      );
      if (response.status === 200) {
        notify('success', 'Details updated successfully');
        return true;
      } else {
        notify('error', 'Details updated failed');
        return false;
      }
    } else {
      const response = await getAxiosInstance().post(
        `/saveClientManagers?access_token=${getAccessToken()}`,
        body
      );
      if (response.status === 200) {
        notify('success', 'Details added successfully');
        return true;
      } else {
        notify('error', 'Something went wrong. Please try again');
        return false;
      }
    }
  } catch (ex) {
    notify('error', 'Something went wrong. Please try again');
    return false;
  }
};

export const deleteUser = userId => async dispatch => {
  try {
    if ((userId || 0) > 0) {
      const response = await getAxiosInstance().put(
        `/deleteUser?userId=${userId}&access_token=${getAccessToken()}`
      );
      if (response.status === 200) {
        notify('success', 'User deleted successfully');
        return true;
      } else {
        notify('error', 'User deleted failed');
        return false;
      }
    } else {
      return false;
    }
  } catch (ex) {
    return false;
  }
};
